/* eslint
    no-empty-function: "warn",
    no-restricted-syntax: "warn"
*/

import {globalEvent} from '@shared/easyfy.core';
import {invoke} from '@shared/easyfy.decorators';
import {hide, show, toggleClass} from '@shared/easyfy.utils';
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';
import { defaultTranslations } from '@webModules/splideHelper';

namespace Easyfy.Components {
  @invoke
  class BannerComponent {

    onInit() {
      BannerComponent.refreshBannerComponent();

      window.addEventListener('BannerComponent', (() => {
        BannerComponent.refreshBannerComponent();
      }) as EventListener);

      globalEvent({
        type: 'click',
        event: {
          event: 'read-more-toggle',
          callback: BannerComponent.onReadMoreToggle
        }
      });

      Splide.defaults = {
        pauseOnFocus: false,
        pauseOnHover: false
      };
    }

    static refreshBannerComponent = (timeout: number = 0) => {
      setTimeout(() => {
        document
          .querySelectorAll('[data-container="banner-slider"]')
          .forEach((item) => {
            const desktopPerViewElement = item.closest(
              '[data-desktop-per-view]'
            ) as HTMLElement;
            let desktopPerView = 3;
            if (desktopPerViewElement) {
              desktopPerView = parseInt(desktopPerViewElement.dataset.desktopPerView, 10);
            }
            item.classList.add('splide');
            const splideOptions = {
              type: 'loop',
              perPage: desktopPerView,
              speed: 900,
              dragMinThreshold: 20,
              flickMaxPages: 1,
              flickPower: 100,
              gap: 24,
              snap: false,
              arrows: true,
              pagination: false,
              breakpoints: {
                1100: {
                  perPage: 2,
                  arrows: true,
                  gap: 16,
                  pagination: false
                },
                768: {
                  arrows: false,
                  perPage: 1,
                  gap: 8,
                  padding: {
                    left: 0,
                    right: 80
                  }
                }
              },
              i18n: defaultTranslations
            };

            if (BannerComponent.shouldSetupAutoplayForSplide(item)) {
              BannerComponent.setupAutoplayForSplide(splideOptions, true);
            }

            const splide = new Splide(item as HTMLElement, splideOptions);

            splide.mount({Intersection});
          });

        document
          .querySelectorAll('[data-container="banner-full"]')
          .forEach((item) => {
            item.classList.add('splide');

            const splideOptions = {
              type: 'loop',
              perPage: 1,
              speed: 900,
              dragMinThreshold: 20,
              flickMaxPages: 1,
              flickPower: 100,
              snap: false,
              arrows: true,
              pagination: false,
              i18n: defaultTranslations
            };

            if (BannerComponent.shouldSetupAutoplayForSplide(item)) {
              BannerComponent.setupAutoplayForSplide(splideOptions);
            }

            const splide = new Splide(item as HTMLElement, splideOptions);

            const toggleAutoplayButton = splide.root.querySelector('.splide__toggle');
            const startAutoplayButton = splide.root.querySelector('.splide__toggle__play');
            const pauseAutoplayButton = splide.root.querySelector('.splide__toggle__pause');

            splide.on('autoplay:pause', () => {
              hide(pauseAutoplayButton);
              show(startAutoplayButton);
              // toggleAutoplayButton.ariaLabel = Splide.defaults.i18n.play;
              toggleAutoplayButton.setAttribute('aria-label', Splide.defaults.i18n.play);
            });

            splide.on('autoplay:play', () => {
              hide(startAutoplayButton);
              show(pauseAutoplayButton);
              // toggleAutoplayButton.ariaLabel = Splide.defaults.i18n.pause;
              toggleAutoplayButton.setAttribute('aria-label', Splide.defaults.i18n.pause);
            });

            splide.mount({Intersection});
          });

        document
          .querySelectorAll('[data-container="banner-slider-icons"]')
          .forEach((item) => {
            item.classList.add('splide');
            new Splide(item as HTMLElement, {
              type: 'loop',
              perPage: 6,
              speed: 500,
              dragMinThreshold: 20,
              flickMaxPages: 1,
              flickPower: 100,
              gap: 24,
              snap: false,
              arrows: true,
              pagination: false,
              breakpoints: {
                1100: {
                  perPage: 2,
                  arrows: true,
                  gap: 16,
                  pagination: false
                },
                768: {
                  perPage: 2,
                  arrows: false,
                  gap: 8,
                  padding: {
                    left: 0,
                    right: item.clientWidth * 0.1
                  }
                }
              },
              i18n: defaultTranslations
            }).mount();
          });
      }, timeout);
    };

    private static shouldSetupAutoplayForSplide(item: Element) {
      return item.classList.contains('autoplay-banner');
    }

    private static setupAutoplayForSplide(splideOptions, scrollOneItemAtATime: boolean = false) {
      splideOptions.autoplay = 'pause';
      splideOptions.interval = 2500;
      splideOptions.intersection = {
        inView: {
          autoplay: true,
        },
        outView: {
          autoplay: false,
        }
      };

      splideOptions.pagination = true;

      if (scrollOneItemAtATime) {
        splideOptions.focus = 0;

        splideOptions.omitEnd = true;
      }

      if (!splideOptions.breakpoints) {
        return;
      }

      for (const breakpointKey of Object.keys(splideOptions.breakpoints)) {
        splideOptions.breakpoints[breakpointKey].pagination = true;
      }
    }

    static onReadMoreToggle(event) {
      const button = event.target;

      // False means we are expanding the text now
      const isTextExpanded = button.dataset.open === 'false';
      const bannerElement = button.closest('.banner-media') as HTMLElement;
      toggleClass(bannerElement, 'show-all-text');

      const textContainer = bannerElement.querySelector(
        '.text-container'
      ) as HTMLElement;

      const innerTextContainer: HTMLElement =
        button.parentElement.querySelector(
          '[data-container="read-more"]'
        ) as HTMLElement;
      toggleClass(innerTextContainer, 'hidden-text');

      if (isTextExpanded) {
        if (textContainer.offsetHeight < bannerElement.offsetHeight) {
          textContainer.style.height = `${bannerElement.getBoundingClientRect().height
          }px`;
        } else {
          bannerElement.style.height = `${textContainer.getBoundingClientRect().height
          }px`;
        }
        const backgroundColor =
          textContainer.dataset.backgroundColor !== undefined
            ? textContainer.dataset.backgroundColor
            : '';
        textContainer.dataset.originalBackgroundColor =
          textContainer.style.background;
        textContainer.style.background = backgroundColor;
        button.dataset.open = 'true';
      } else {
        bannerElement.style.height = '';
        textContainer.style.height = '';
        const originalbgColor =
          textContainer.dataset.originalBackgroundColor !== undefined
            ? textContainer.dataset.originalBackgroundColor
            : '';
        textContainer.style.background = originalbgColor;
        button.dataset.open = 'false';
      }

      const {toggleText} = button.dataset;
      const linkText = button.textContent;
      button.textContent = toggleText;
      button.dataset.toggleText = linkText;

      return false;
    }
  }
}
